
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 43.7 42.6\" id=\"icon-download\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M10.4,22.9c-0.8-0.8-0.8-2.2,0-3c0.8-0.8,2.2-0.8,3,0l6.3,6.3V2.1c0-1.2,1-2.1,2.1-2.1C23,0,24,1,24,2.1\r\n\tv24.1l6.3-6.3c0.8-0.8,2.2-0.8,3,0c0.4,0.4,0.6,0.9,0.6,1.5s-0.2,1.1-0.6,1.5l-9.9,10c-0.4,0.4-0.9,0.6-1.5,0.6\r\n\tc-0.6,0-1.1-0.2-1.5-0.6L10.4,22.9z M41.6,27.4c-1.2,0-2.1,0.9-2.1,2.1v8.8H4.2v-8.8c0-1.2-1-2.1-2.1-2.1c-1.2,0-2.1,0.9-2.1,2.1\r\n\tv10.9c0,1.2,0.9,2.1,2.1,2.1h39.5c1.2,0,2.1-1,2.1-2.1V29.5C43.7,28.3,42.8,27.4,41.6,27.4z\"/> </symbol>";
module.exports = sprite.add(image, "icon-download");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/download.svg
 ** module id = 169
 ** module chunks = 24
 **/